export default __webpack_public_path__ + "static/media/BG2.dcc19e10.jpg";